
import store from '../../store'
export default {
  className: 'priceLog',
  perPage: 30,
  mixin: {
    fields: [
      {
        // 名称
        name: 'name'
      },

      {
        // 用户
        name: 'user',
        note: '操作人'
      },
      {
        name: 'describe'
      },
      {
        // 变动原因
        name: 'reason'
      },
      'updatedAt'
    ],
    search: [
      'name',
      'user',
      'reason',
      'updatedAt',
    ],
    hooks: {
      beforeFetch ({ where }) {
        where.type = 'finishProduct'
      },
    },
    action: {
      delete: store.state.user && store.state.user.authority.finishProductLog.del ? {
        type: 'row',
        text: '删除',
        callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
          await vm.confirm('警告', '你确定要删除这条记录吗?')
          let rs = await vm.$modelAjax.delete(modelName, record.objectId).catch(() => {
            this.$notification['error']({
              message: '网络错误',
              description: '删除数据失败'
            })
          })
          if (rs) {
            vm.$notification['success']({
              message: '操作成功',
              description: '记录已被删除'
            })
            vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
          }
        }
      } : false,
    }
  },
}
